import { render, staticRenderFns } from "./xitongduijie.vue?vue&type=template&id=c08f3c32&scoped=true&"
import script from "./xitongduijie.vue?vue&type=script&lang=ts&"
export * from "./xitongduijie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08f3c32",
  null
  
)

export default component.exports